import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {
  transform(lista: any[], busca: string, propriedade: string): any[] {
    if (!lista || !busca) return lista;
    return lista.filter(item =>
      item[propriedade].toLowerCase().includes(busca.toLowerCase())
    );
  }
}